"use strict";
exports.__esModule = true;
var ramda_1 = require("ramda");
exports["default"] = ramda_1.pick([
    'autoplay',
    'controls',
    'height',
    'loop',
    'muted',
    'poster',
    'preload',
    'src',
    'width',
]);
//# sourceMappingURL=video.js.map